// import { useEffect, useState } from "react";
// import axiosInstance from "../utils/axiosInstance";

// /**
//  * Custom hook to detect the visitor's country.
//  *
//  * Flow:
//  * 1. Try GPS location (if the user grants permission).
//  * 2. Get country from the backend /locations API.
//  * 3. If GPS is unavailable or fails, fall back to the /tracking API.
//  * 4. If everything fails, default to "US".
//  */
// const useCountry = () => {
//   // null = still loading
//   // "US", "IN", etc. = detected country
//   const [country, setCountry] = useState(null);

//   useEffect(() => {
//     const fetchCountry = async () => {
//       // Get the user's GPS coordinates (if permitted)
//       const gpsLocation = await new Promise((resolve) => {
//         if (!window.navigator?.geolocation) {
//           resolve(null);
//           return;
//         }

//         window.navigator.geolocation.getCurrentPosition(
//           (pos) => resolve(pos.coords),
//           () => resolve(null),
//           {
//             enableHighAccuracy: true,
//             timeout: 10000,
//             maximumAge: 0,
//           },
//         );
//       });

//       // First preference: GPS-based lookup
//       if (gpsLocation) {
//         try {
//           const { data } = await axiosInstance.get(
//             `/api/locations?latitude=${gpsLocation.latitude}&longitude=${gpsLocation.longitude}`,
//           );

//           setCountry(data.country_code || "US");
//           return;
//         } catch {
//           console.log("GPS lookup failed. Falling back to IP lookup.");
//         }
//       }

//       // Second preference: IP-based lookup
//       try {
//         const { data } = await axiosInstance.get("/api/tracking");
//         setCountry(data.country || "US");
//       } catch {
//         console.log("IP lookup failed. Using default country.");
//         setCountry("US");
//       }
//     };

//     fetchCountry();
//   }, []);

//   return country;
// };

// export default useCountry;

import { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";

/**
 * Custom hook to detect the visitor's country using the backend tracking API.
 *
 * Flow:
 * 1. Call the backend /tracking API.
 * 2. Return the detected country code.
 * 3. If the request fails, default to "US".
 */
const useCountry = () => {
  // null = loading
  const [country, setCountry] = useState(null);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const { data } = await axiosInstance.get("/api/tracking");

        //API returns "IN", "US", etc.
        setCountry(data.country || "US");
      } catch (error) {
        console.error("Failed to fetch country:", error);
        setCountry("US");
      }
    };

    fetchCountry();
  }, []);

  return country;
};

export default useCountry;
